import { commonFacebookEventsUtil } from '@/shared/features/analytics/utils/facebookCommonAttributes';
import type { ListingDesignItem } from '@/features/plp/domain/models/ProductListing';

export interface FacebookRecentlyViewedOpenedParams {
  designs: ListingDesignItem[];
  totalCount: number;
  sourcePage?: string;
}

export function facebookRecentlyViewedOpened({
  designs,
  totalCount,
  sourcePage = '',
}: FacebookRecentlyViewedOpenedParams): void {
  if (totalCount <= 0 || !designs.length) return;

  const visible = designs.slice(0, 9);
  commonFacebookEventsUtil('RecentlyViewedOpened', {
    content_ids: visible.map((d) => String(d.designId)),
    content_names: visible.map((d) => d.designName),
    content_category: visible[0]?.categoryType ?? '',
    content_type: 'product',
    num_items: totalCount,
    currency: 'INR',
    source_page: sourcePage,
  });
}
